




























































































import { ViberBulkDistrItemImpl } from "@/store/user_management/distr_moderation/types";
import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {InputWings, TextareaWings} from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import {uploadedFile} from "@/store/viber/templates/types";

@Component({components: {InputWings, TextareaWings}})
export default class ViberDistribution extends Vue {
  @Action("getBulkDistrItem") actionGetDistributionItem: any;
  @Action("actionLog") actionLog: any;
  @Action("getFile") actionGetFile: any;

  private distribution = new ViberBulkDistrItemImpl();
  // private distributionSaved = this.defaultDistribution();
  private logObject: ActionLog = {};
  private uploadedFile?: uploadedFile | null = null;

 async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Distribution",
          addititional_info: getTranslatedParams({channel: this.$route.params.channel, id: this.$route.params.id})
        }
        await this.actionGetDistributionItem(this.$route.params.id).then((data: ViberBulkDistrItemImpl) => {
          this.distribution = Object.assign({}, this.distribution, data);
          // this.distributionSaved = cloneDeep(Object.assign({}, this.distribution, data));
        });
        await this.actionLog(this.logObject);
        if (this.distribution.attachment_file_id) {
          try {
            const resp = await this.actionGetFile(this.distribution.attachment_file_id);
            this.uploadedFile = resp.data;
          } catch(error) {
            notifyError(error);
          }
        }
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }
}
